import {Component, Input, Output, ChangeDetectionStrategy,EventEmitter} from "@angular/core";
import {ISelectableItems, ISelectableItem} from "../interfaces/selectable.items.list";
import {LogCat} from "../../../../log/services/log.manager.categories";
import {LogManager} from "../../../../log/services/log.manager";
/**
	* Created by shahar on 05-Jul-16.
	*/
/**
	* component to show a list of items and allow item selection.
	* the items are basic items, showing a description for each of them.
	*/
@Component({
	selector:'cp-selectable-items-widget',
	templateUrl: './selectable.items.list.template.html',
	styleUrls: ['./selectable.items.list.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectableItemsComponent {
	@Input() items:ISelectableItems;
	@Output() select:EventEmitter<ISelectableItem> = new EventEmitter<ISelectableItem>();

	public selectItem(item:ISelectableItem){
		LogManager.debug(LogCat.UI.SelecrtableList,"item select for ",item);
		this.select.emit(item);
	}
}
